import type { FC } from "react";

import OG_URL from "@application/images/social/og.jpeg";
import TWITTER_URL from "@application/images/social/twitter.jpeg";

import { Title } from "./title";

export const Social: FC<{
  type?: "profile" | "article" | "website";
  title: string;
  description: string;
  url: string;
}> = ({ type = "website", title, description, url }) => {
  // Vite resolves the image imports to root-relative paths; Open Graph consumers
  // fetch the value with no base URL, so they have to be absolute.
  const { origin } = new URL(url);

  return (
    <>
      <Title>{title}</Title>

      <meta name="description" content={description} />

      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={`${origin}${OG_URL}`} />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:image" content={`${origin}${TWITTER_URL}`} />
    </>
  );
};
